import * as React from "react";
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import type { ComponentProps } from "widgets/BaseComponent";
import _ from "lodash";
import "./index.css";
import styled from "styled-components";
import { parseWidgetData } from "@byk/utils/Utils";
import BaiduMap from "@byk/pages/components/BMapWidget";
import { Effects } from "@icon-park/react/es/map";
import { Button } from "antd";
import { MapApiLoaderHOC } from "react-bmapgl";
import { commitUpdateSyncBatchUpdateWidgetMetaProperties } from "ce/sagas/ActionExecution/XActionExecutionSagas";
import { getStorage } from "utils/localStorage";

const ContainerWrapper = styled.div<{
}>`
  height:'300px';
`;

function BmapComponent (props: any) {
  const {
    value,
    onChange,
    isSearch,
    dragEnable,
    zoomEnable,
    zoomLevel,
    currentData,
    isShowCard,
    borderColor,
    borderWidth,
    borderRadius,
    boxShadow,
    centerLnglat,
    rotation,
    pitch,
    viewMode,
    isSetCenter,
    isShowPolyline,
    enableDoubleClickZoom,
    enableRotate,
    enableTilt,
    noChooseMarkerColor,
    chooseMarkerColor,
    onMarkerRightClick,
    onMapClick,
    contentCfg,
    isShowDrawingManager,
    InfoWindowWidth,
    titleCfg,
    iconWidth,
    iconHeight,
    isShowSelect,
    onDataChange,
    onCalcPointsDistance,
    isEnableMarkerRightClick,
    extData,
    chooseAddress,
    coverageRadius,
    onCurrentLocationChange,
    enableDistance,
    enableChoosePoint,
    locationMarkerKey,
    currentLocationKey,
    displayOptionsPoiText,
    displayOptionsPoiIcon,
    displayOptionsBuilding,
    displayOptionsIndoor,
    isShowMarkerLabel,
    iconsConfig, // 图标配置信息
  } = props;
  const doPositionRef = useRef<any>(0);

  // 将数据统一转换为数组格式，兼容 JSON 对象格式（key-value）和旧数组格式
  const toArrayData = (data: any): any[] => {
    if (data == null || data == undefined) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === 'object') {
      const values = Object.values(data);
      if (values.length > 0 && values[0] && typeof values[0] === 'object') {
        return values;
      }
      return [];
    }
    return [];
  };

  // 使用 useMemo 缓存 _value，避免每次渲染都创建新引用
  const _value = useMemo(() => {
    const raw = parseWidgetData(value || currentData);
    return toArrayData(raw);
  }, [value, currentData]);

  const chooseMapRef = useRef<any>(null);
  const onItemClick = useCallback((v: any) => {
    onChange && onChange(v);
  }, [onChange]);
  const getBmapMappingData=(data:any, keepPrefix = true)=> {
    if (Array.isArray(data)) {
        return data.map(item => getBmapMappingData(item, keepPrefix));
    }
    if (data && typeof data === 'object') {
        const result:any = {};
        Object.keys(data).forEach(key => {
            if (key.includes(`${props.widgetName}.mapping`)) {
                if (keepPrefix) {
                    result[key] = data[key];
                } else {
                    const newKey = key.replace(`${props.widgetName}.mapping.`, '');
                    result[newKey] = data[key];
                }
            }
            else{
               result[key] = data[key];
            }
        });
        return result;
    }
    return data;
}


useEffect(() => {
  //console.log("------isShowSelect--------------",isShowSelect)
    chooseMapRef.current?.setGroupShow(isShowSelect)
}, [isShowSelect]);


useEffect(() => {
  if(extData!=null&&extData!=undefined){
    const extDataArray = toArrayData(extData);
    chooseMapRef.current?.setPointsByExtData(extDataArray)
  }
}, [extData]);

const doOnCurrentLocationChange=(_location:any,isFlag:boolean=false)=>{
  if(isFlag){
    doPositionRef.current=0;
  }
  if(doPositionRef.current==0){
    onCurrentLocationChange(_location,getStorage(locationMarkerKey)=="0")
    doPositionRef.current=doPositionRef.current+1;
  }
}

const DataDom = useCallback((props:any) => {
  return <BaiduMap
      ref={chooseMapRef}
      callback={onItemClick}
      mode={"view"}
      defaultLngLat={_value}
      currentData={getBmapMappingData(_value,false)}
      centerLnglat={centerLnglat&&centerLnglat[0]}
      isShowCard={isShowCard}
      dragEnable={dragEnable}
      zoomLevel={zoomLevel}
      zoomEnable={zoomEnable}
      isSearch={isSearch}
      borderColor={borderColor}
      borderWidth={borderWidth}
      borderRadius={borderRadius}
      rotation={rotation}
      pitch={pitch}
      viewMode={viewMode}
      boxShadow={boxShadow}
      //mapStyle={mapStyle}
      //features={features}
      isSetCenter={isSetCenter}
      isShowPolyline={isShowPolyline}
      /** 是否开启双击鼠标缩放 */
      enableDoubleClickZoom={enableDoubleClickZoom}
      /** 是否开启地图旋转功能 */
      enableRotate={enableRotate}
      /** 是否开启地图倾斜功能 */
      enableTilt={enableTilt}
      noChooseMarkerColor={noChooseMarkerColor}
      chooseMarkerColor={chooseMarkerColor}
      onMarkerRightClick={onMarkerRightClick}
      onMapClick={onMapClick}
      onDataChange={onDataChange}
      onCalcPointsDistance={onCalcPointsDistance}
      contentCfg={contentCfg}
      isShowDrawingManager={isShowDrawingManager}
      InfoWindowWidth={InfoWindowWidth}
      titleCfg={titleCfg}
      iconWidth={iconWidth}
      iconHeight={iconHeight}
      isEnableMarkerRightClick={isEnableMarkerRightClick}
      isShowMarkerLabel={isShowMarkerLabel}
      chooseAddress={chooseAddress}
      coverageRadius={coverageRadius}
      onCurrentLocationChange={doOnCurrentLocationChange}
      enableDistance={enableDistance}
      enableChoosePoint={enableChoosePoint}
      locationMarkerKey={locationMarkerKey}
      currentLocationKey={currentLocationKey}
      displayOptionsPoiText={displayOptionsPoiText}
      displayOptionsPoiIcon={displayOptionsPoiIcon}
      displayOptionsBuilding={displayOptionsBuilding}
      displayOptionsIndoor={displayOptionsIndoor}
      iconsConfig={iconsConfig}
    />
  }, [
    value,
    isSearch,
    dragEnable,
    zoomEnable,
    zoomLevel,
    currentData,
    isShowCard,
    borderColor,
    borderWidth,
    borderRadius,
    boxShadow,
    centerLnglat,
    rotation,
    pitch,
    viewMode,
    isSetCenter,
    isShowPolyline,
    enableDoubleClickZoom,
    enableRotate,
    enableTilt,
    noChooseMarkerColor,
    chooseMarkerColor,
    contentCfg,
    isShowDrawingManager,
    InfoWindowWidth,
    titleCfg,
    iconWidth,
    iconHeight,
    isEnableMarkerRightClick,
    coverageRadius,
    onCurrentLocationChange,
    enableDistance,
    enableChoosePoint,
    locationMarkerKey,
    currentLocationKey,
    displayOptionsPoiText,
    displayOptionsPoiIcon,
    displayOptionsBuilding,
    displayOptionsIndoor,
    isShowMarkerLabel,
    iconsConfig
  ]);

  return (
    <>
      <ContainerWrapper className="z-AmapViewWidget-ContainerWrapper" style={{
        height: "inherit",
        border: `${borderWidth}px solid ${borderColor || "#bcb3b3"}`,
        boxShadow: boxShadow,
        borderRadius: borderRadius
      }} {...props}>
        <DataDom></DataDom>
      </ContainerWrapper>
    </>
  )
};

export default MapApiLoaderHOC({ ak: '4YuxDaLyOsqf2SnUtS7ZI1gvlS8wRuSK' })(BmapComponent);
